import { z } from 'zod';

import { MEMBERSHIP_ROLES, MEMBERSHIP_STATUSES } from './workspace.js';

/**
 * Who else is in the workspace - API-004.
 *
 * The one route addressed by the `x-workspace-id` header rather than by a path
 * segment, which is what ADR-030 says every workspace-scoped resource looks
 * like. `/v1/workspaces/{id}` is the exception, not the pattern.
 */
export const memberSchema = z
  .object({
    userId: z.uuid(),
    email: z.string(),
    displayName: z.string(),
    role: z.enum(MEMBERSHIP_ROLES),
    status: z.enum(MEMBERSHIP_STATUSES),
    /** Absent while the invitation is unaccepted - `membership_joined_at_matches_status`. */
    joinedAt: z.string().optional(),
  })
  .readonly();

export const memberListResponseSchema = z
  .object({ members: z.array(memberSchema).readonly() })
  .readonly();

export type Member = z.infer<typeof memberSchema>;
export type MemberListResponse = z.infer<typeof memberListResponseSchema>;
